import { Outlet, NavLink, useLocation, Navigate } from 'react-router-dom'
import { User, Activity } from 'lucide-react'
import { cn } from '@/lib/utils'

const navItems = [
  { icon: User, label: 'Profile', href: '/account/profile' },
  { icon: Activity, label: 'Activity', href: '/account/activity' },
]

export function AccountLayout() {
  const location = useLocation()

  // Redirect /account to /account/profile
  // Also redirect /account/security to /account/profile since they're now unified
  if (location.pathname === '/account' || location.pathname === '/account/security') {
    return <Navigate to="/account/profile" replace />
  }

  return (
    <div className="flex gap-8">
      {/* Sidebar navigation */}
      <nav className="w-48 shrink-0 hidden md:block">
        <ul className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon
            return (
              <li key={item.href}>
                <NavLink
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-[var(--bg-elevated-2)] text-[var(--text-primary)]'
                        : 'text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] hover:text-[var(--text-primary)]'
                    )
                  }
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </NavLink>
              </li>
            )
          })}
        </ul>
      </nav>

      {/* Main content */}
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  )
}

export { AccountPage } from './account'
export { ActivityPage } from './activity'

// Keep old exports for backwards compatibility during transition
export { AccountPage as ProfilePage } from './account'
export { AccountPage as SecurityPage } from './account'
